/**
 * O termo é o nome de uma cidade que os mapas conhecem? União dos nomes de
 * `AIRPORT_CITIES` (pt-BR curado), `METRO_AREAS` e `AIRPORT_CITIES_WORLD`
 * (~7k aeroportos, grafia do dataset), dobrados sem acento/caixa.
 *
 * Existe para a invariante I2 do ranker de candidatos do planner de voo
 * (#3383): se o cliente disse uma cidade que EXISTE e nenhum candidato do
 * voll-places a serve, a lista está errada — o ranker devolve `null` em vez
 * de aceitar "Porto Alegre" para "Porto" ou "Vitória da Conquista" para
 * "Vitória". Sem este conjunto o ranker só saberia que houve texto em comum.
 *
 * Pure (no IO): conjunto montado uma vez no load do módulo.
 */

import { AIRPORT_CITIES } from './airport_cities.js';
import { AIRPORT_CITIES_WORLD } from './airport_cities_world.js';
import { foldAlias } from './fold_alias.js';
import { METRO_AREAS } from './metro_city.js';

const KNOWN_CITIES: ReadonlySet<string> = new Set(
  [
    ...Object.values(AIRPORT_CITIES),
    ...Object.values(AIRPORT_CITIES_WORLD),
    ...Object.values(METRO_AREAS).map((area) => area.city),
  ].map(foldAlias),
);

/** `true` quando o termo dobrado é exatamente o nome de uma cidade conhecida. */
export function isKnownCity(term: string | null | undefined): boolean {
  if (!term) return false;
  const key = foldAlias(term);
  return key.length > 0 && KNOWN_CITIES.has(key);
}
